<template>
  <div class="wrapper">
    <div class="back" v-if="arrow==='up'" @click.stop="arrow='down'"></div>
    <div class="content"  @click.stop="clickIcon">
      <Icon type="ios-arrow-down" v-if="arrow==='down'"></Icon>
      <Icon type="ios-arrow-up" v-if="arrow==='up'" ></Icon>

      <div class="desc" v-show="arrow==='up'">
        <slot></slot>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "Tip",
    data(){
      return {
        arrow:'down'

      }
    },
    methods:{
      clickIcon(){
      this.arrow= this.arrow==='down'?'up':'down'

      }
    }
  }
</script>

<style scoped>
  .wrapper,.content{
    width: 100%;
    height: 100%;
  }
  .content{
    position: relative;

  }

  .desc{
    position: absolute;
    width: 150px;
    padding: 10px;
    /*background-color: white;*/
    left:-20px;
    font-size: 12px;
    text-align: left;
    line-height: 2;
    z-index: 1000;
    background-color:  rgb(150, 150, 150);
    color: white;
    border-radius: 4px;


  }
  .back{
    width: 100vw;
    height:100vh;
    position: fixed;
    /*background-color: lightcoral;*/
    top: 0;
    left: 0;
    z-index: 1000;

  }



</style>
